import { router } from 'expo-router';
import { useSetAtom } from 'jotai';
import { isNonMobileWeb } from 'smoothie';

import { goalsExplanationSimpleModalIsOpenAtom } from '../state/GoalAtoms';

export const useShowGoalsExplanation = () => {
    const setGoalsExplanationSimpleModalIsOpen = useSetAtom(
        goalsExplanationSimpleModalIsOpenAtom,
    );

    return (isOpen: boolean = true) => {
        setGoalsExplanationSimpleModalIsOpen(isOpen);
        if (!isNonMobileWeb) {
            if (isOpen) {
                router.navigate('/goals/goals-explanation');
            } else {
                router.canGoBack() ? router.back() : router.navigate('/home');
            }
        }
    };
};
